export enum Roles {
  ADMIN = 'admin',
  TENANT = 'tenant',
  SUPER_ADMIN = 'super-admin',
}
